import {
  getTodayDates,
  getYesterdayDates,
  getCurrentWeekDates,
  getLast30DaysDates,
  getPreviousMonthDates,
  getMonthBeforePreviousMonthDates
} from "./../utilities/datesFormatter";

export const SET_START_DATE = "dates/SET_START_DATE";
export const SET_END_DATE = "dates/SET_END_DATE";
export const SET_TODAY = "dates/SET_TODAY";
export const SET_YESTERDAY = "dates/SET_YESTERDAY";
export const SET_CURRENT_WEEK = "dates/SET_CURRENT_WEEK";
export const SET_LAST30_DAYS = "dates/SET_LAST30_DAYS";
export const SET_PREVIOUS_MONTH = "dates/SET_PREVIOUS_MONTH";
export const SET_PAST_PREVIOUS_MONTH = "dates/SET_PAST_PREVIOUS_MONTH";
export const CLEAR_SHORTCUT = "dates/CLEAR_SHORTCUT";

const todayDates = getTodayDates();

const initialState = {
  startDate: todayDates.startDate,
  endDate: todayDates.endDate,
  zone: new Date().getTimezoneOffset() / -60,
  selectedShortcut: 2
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_START_DATE:
      return {
        ...state,
        startDate: action.date,
        selectedShortcut: 1
      };

    case SET_END_DATE:
      return {
        ...state,
        endDate: action.date,
        selectedShortcut: 1
      };

    case SET_TODAY:
    case SET_YESTERDAY:
    case SET_CURRENT_WEEK:
    case SET_LAST30_DAYS:
    case SET_PREVIOUS_MONTH:
    case SET_PAST_PREVIOUS_MONTH:
      return {
        ...state,
        startDate: action.startDate,
        endDate: action.endDate,
        selectedShortcut: action.selectedShortcut
      };

    case CLEAR_SHORTCUT:
      return {
        ...state,
        selectedShortcut: 1
      };

    default:
      return state;
  }
};

export const setStartDate = date => {
  return dispatch => {
    dispatch({
      type: SET_START_DATE,
      date
    });
  };
};

export const setEndDate = date => {
  return dispatch => {
    dispatch({
      type: SET_END_DATE,
      date
    });
  };
};

export const setToday = () => {
  const dates = getTodayDates();
  return dispatch => {
    dispatch({
      type: SET_TODAY,
      startDate: dates.startDate,
      endDate: dates.endDate,
      selectedShortcut: 2
    });
  };
};

export const setYesterday = () => {
  const dates = getYesterdayDates();
  return dispatch => {
    dispatch({
      type: SET_YESTERDAY,
      startDate: dates.startDate,
      endDate: dates.endDate,
      selectedShortcut: 3
    });
  };
};

export const setCurrentWeek = () => {
  const dates = getCurrentWeekDates();
  return dispatch => {
    dispatch({
      type: SET_YESTERDAY,
      startDate: dates.startDate,
      endDate: dates.endDate,
      selectedShortcut: 4
    });
  };
};

export const setLast30Days = () => {
  const dates = getLast30DaysDates();
  return dispatch => {
    dispatch({
      type: SET_YESTERDAY,
      startDate: dates.startDate,
      endDate: dates.endDate,
      selectedShortcut: 5
    });
  };
};

export const setPreviousMonth = () => {
  const dates = getPreviousMonthDates();
  return dispatch => {
    dispatch({
      type: SET_YESTERDAY,
      startDate: dates.startDate,
      endDate: dates.endDate,
      selectedShortcut: 6
    });
  };
};

export const setPastPreviousMonth = () => {
  const dates = getMonthBeforePreviousMonthDates();
  return dispatch => {
    dispatch({
      type: SET_YESTERDAY,
      startDate: dates.startDate,
      endDate: dates.endDate,
      selectedShortcut: 7
    });
  };
};

export const clearShortcut = () => {
  return dispatch => {
    dispatch({
      type: CLEAR_SHORTCUT,
      selectedShortcut: 1
    });
  };
};



// WEBPACK FOOTER //
// ./src/modules/dates.js